export const chartColors = ['#ED553B', '#F6D55C', '#3CAEA3', '#20639B', '#173F5F'];
